import './acoesCaixa.css';

const escapar = valor => String(valor).replace(/&/g,'&amp;').replace(/</g,'&lt;').replace(/>/g,'&gt;').replace(/"/g,'&quot;').replace(/'/g,'&#39;');

export function iconeAcaoCaixa(tipo, titulo, classe) {
  return `<button type="button" class="mbhair-acao-caixa" data-acao="${escapar(tipo)}" title="${escapar(titulo)}" aria-label="${escapar(titulo)}"><i class="${escapar(classe)}" aria-hidden="true"></i></button>`;
}

// Padrao: cada acao conserva sua posicao, mesmo quando as demais nao existem.
export function formatarAcoesCaixa(acoes) {
  return '<span class="mbhair-acoes-caixa">'+['editar','profissional','reverter'].map(posicao =>
    `<span class="mbhair-acao-caixa-posicao" data-posicao="${posicao}"${acoes[posicao]?'':' aria-hidden="true"'}>${acoes[posicao]||''}</span>`
  ).join('')+'</span>';
}

export function formatarIdMovimentoCaixa(cell) {
  const valor=String(cell.getValue()??'').trim();
  if (!/^\d+$/.test(valor)) return '-';
  const botao=document.createElement('button');
  botao.type='button';
  botao.className='mbhair-id-movimento-caixa';
  botao.textContent=valor;
  botao.title='Abrir detalhamento completo do movimento #'+valor;
  return botao;
}
